import { Stack } from "@mui/material";
import { Icon, IconType } from "../../../../icons";
import styles from "./styles.module.scss";

export const StarsRating = ({ value }: { value: number }) => {
  return (
    <Stack direction="row" spacing={"-4px"}>
      {Array.from({ length: 5 }, (_, i) => (
        <Icon className={styles.icon} key={i} type={IconType.Star} filled={i <= value} />
      ))}
    </Stack>
  );
};
